import { useAppConfigContext } from '~/contexts/AppConfig';
import { EmailInput } from '~/eds/src/components/EmailInput/EmailInput';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { TextArea } from '~/eds/src/components/TextArea/TextArea';
import { TextInput } from '~/eds/src/components/TextInput/TextInput';
import { WorkflowFieldType } from '~/enums/WorkflowFieldType';
import { Nullable } from '~/types/Nullable';

import { WorkflowQuestionFormField } from './types';

export const TextWorkflowQuestion = ({
  question,
  onChange,
  type,
  ...rest
}: {
  type:
    | WorkflowFieldType.ShortResponse
    | WorkflowFieldType.Email
    | WorkflowFieldType.LongResponse
    | WorkflowFieldType.Reference;
} & WorkflowQuestionFormField<Nullable<string>>) => {
  const { isPanelEnlarged } = useAppConfigContext();
  const {
    field: { value, wellKnownKey },
  } = question;

  let displayValue = value.value;
  if (type === WorkflowFieldType.Reference && value.value) {
    if (typeof value.value === 'object') {
      displayValue = value.value.default_value || null;
    }
  }

  let InputComponent = TextInput;
  if (type === WorkflowFieldType.Email) {
    InputComponent = EmailInput;
  } else if (
    type === WorkflowFieldType.LongResponse ||
    (type === WorkflowFieldType.ShortResponse &&
      wellKnownKey === 'contract_description')
  ) {
    InputComponent = TextArea;
  }

  return (
    <FormField
      {...rest}
      input={InputComponent}
      value={displayValue}
      onChange={(val) => onChange(val, 'value')}
      inputProps={{
        width: isPanelEnlarged ? 'input.l.width' : '100%',
      }}
    />
  );
};
